import React, { useContext } from 'react'
import { Grid } from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import Stack from "@mui/material/Stack";
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { UiButton } from '../../../_uiComponents/common/form/UiButton';
import { contextApiActions } from "../../../../_redux/_constants";
import { Context } from "../../../../_context/Store";
import {
    ApprovedIcon,
    NotApprovedIcon,
} from "../../../_uiComponents/common/DataGridComponents";
import { useSelector } from 'react-redux';

export default function ParticipantUserResponse(props) {

    const [state, dispatch] = useContext(Context);

    const { participantUserStatus } = useSelector((state) => {
        return {
            participantUserStatus: state.dataTemplate.participantUserCreateStatus
        };
   });

    const headings = [
        { id: 'email', name: 'Email ' },
        { id: 'isParticipantAccountCreated', name: ' Account Created' },
        { id: 'remarks', name: 'Remarks' },

    ]

    const handleExport = () =>{
        dispatch({
             type: contextApiActions.UI_EXTRA_LARGE_MODAL_TOGGEL,
             payload: {
                  show: false,
                  
             }
        })
   }
    return (
        <>
           
            <Grid container spacing={2} sx={{ mt: 0.2 }}>
                <Grid item xs={12} lg={12}>
                    <div className='sba-table-main-wr sba-user-response-table'>
                        <TableContainer component={Paper} sx={{ maxHeight: 340 }}>
                            <Table stickyHeader sx={{ minWidth: 650, mt: 0 }} aria-label="simple table" className='sbt-data-grid'>
                                <TableHead>
                                    <TableRow>
                                        {headings.map((heading, index) => (
                                            <TableCell align="left">
                                                {heading.name}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {participantUserStatus.map((row, index) => (
                                        <TableRow key={index.id}>
                                            <TableCell align="left">
                                                {row.email}
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.account_created ? <ApprovedIcon/> : <NotApprovedIcon/>}
                                            </TableCell>
                                            <TableCell align="center">
                                                {row.remarks}  
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>

                </Grid>
                <Grid item xs={12} lg={12} className='sba-export-records-btn'>
                    <Stack spacing={2} direction="row" justifyContent="end" sx={{ width: '100%', mt: 3 }}>
                        <UiButton name="Export Summary" variant="contained" size="small" onClick={handleExport} />
                    </Stack>
                </Grid>
            </Grid>

        </>
    )
}
